"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const isRTL = props => {
  return props.dir === "rtl";
};
const reverseTransform = "scale(-1, 1)";
const SvgJoinLeft = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  transform: isRTL(props) ? reverseTransform : null,
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.158 16.78A7.1 7.1 0 0 0 15 12a7.1 7.1 0 0 0-1.842-4.78A5.622 5.622 0 0 0 10.5 12a5.623 5.623 0 0 0 2.658 4.78Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 6.19a7.125 7.125 0 1 0 0 11.621 7.127 7.127 0 0 1 0-11.62Zm1.158 1.03a5.625 5.625 0 1 1 0 9.56A7.054 7.054 0 0 1 12 17.811a7.123 7.123 0 0 0 7.394.519A7.126 7.126 0 1 0 12 6.19c.423.302.81.645 1.158 1.03Z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgJoinLeft);
var _default = exports.default = ForwardRef;